import { useEffect, useRef } from "react";
import Eyebrow from "./ui/Eyebrow.jsx";
import Display from "./ui/Display.jsx";
import IconBtn from "./ui/IconBtn.jsx";
import { I } from "./Icons.jsx";

const Seg = ({ options, value, onChange }) => (
  <div style={{
    display: "flex",
    border: "1px solid var(--line-2)",
    borderRadius: 8,
    overflow: "hidden",
    background: "var(--paper-0)",
  }}>
    {options.map(opt => (
      <button
        key={opt.value}
        type="button"
        onClick={() => onChange(opt.value)}
        style={{
          flex: 1,
          padding: "7px 10px",
          background: value === opt.value ? "var(--ink)" : "transparent",
          color: value === opt.value ? "var(--paper-0)" : "var(--ink-2)",
          border: "none",
          fontSize: 12,
          fontFamily: "var(--ui)",
          fontWeight: value === opt.value ? 600 : 500,
          cursor: "pointer",
          letterSpacing: 0.2,
          textTransform: "capitalize",
          transition: "background 0.12s",
        }}
      >{opt.label}</button>
    ))}
  </div>
);

export default function SettingsPopover({ anchor, theme, setTheme, navMode, setNavMode, poolPosition, setPoolPosition, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target) && anchor && !anchor.contains(e.target)) {
        onClose();
      }
    };
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
  }, [anchor, onClose]);

  return (
    <div ref={ref} style={{
      position: "absolute",
      right: 24,
      top: 62,
      zIndex: 500,
      background: "var(--paper-0)",
      border: "1px solid var(--line-2)",
      borderRadius: 12,
      padding: "18px 20px",
      width: 320,
      boxShadow: "0 12px 36px rgba(34,28,20,0.14)",
      fontFamily: "var(--ui)",
    }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 18 }}>
        <div style={{ flex: 1 }}>
          <Eyebrow>Appearance</Eyebrow>
          <Display size={18} style={{ marginTop: 4 }}>Tune your view</Display>
        </div>
        <IconBtn icon={I.x} title="Close" onClick={onClose} />
      </div>

      <div style={{ marginBottom: 14 }}>
        <Eyebrow style={{ marginBottom: 8 }}>Colour theme</Eyebrow>
        <Seg
          value={theme}
          onChange={setTheme}
          options={[
            { value: "ivory", label: "Ivory" },
            { value: "slate", label: "Slate" },
            { value: "sage",  label: "Sage" },
            { value: "dusk",  label: "Dusk" },
          ]}
        />
      </div>

      <div style={{ marginBottom: 14 }}>
        <Eyebrow style={{ marginBottom: 8 }}>Navigation</Eyebrow>
        <Seg
          value={navMode}
          onChange={setNavMode}
          options={[
            { value: "sidebar", label: "Sidebar" },
            { value: "topbar", label: "Topbar" },
          ]}
        />
      </div>

      <div>
        <Eyebrow style={{ marginBottom: 8 }}>Guest pool</Eyebrow>
        <Seg
          value={poolPosition}
          onChange={setPoolPosition}
          options={[
            { value: "top", label: "Top" },
            { value: "side", label: "Side" },
          ]}
        />
      </div>
    </div>
  );
}
